<template>
  <div class="container-box">
    <div class="header">任务详情</div>
    <div class="body" v-if="taskInfo.id">
      <img :src="taskInfo.productPicture" alt="" width="100%"/>
      <div class="goods-name">{{ taskInfo.productName }}</div>
      <div class="tips">
        <div><strong>温馨提示：</strong></div>
        <div>1.切记无需自己付款，如果自己付款了请联系主持提供支付凭证截图后会原路退回！</div>
        <div>2.商品订单号需对应周转码上传！</div>
      </div>
    </div>
    <div class="footer">
      <div class="btn" @click="addTaskSubmit">
        <span>接受任务</span>
      </div>
    </div>
  </div>
</template>
<script>
  import AJAX from "@/utils/AJAX.js";
  import router from "@/router";
  import {Dialog} from "vant";
  export default {
    data() {
      return {
        taskInfo: {},
        orderInfo: {
          amount: 0
        },
        disabled: false
      }
    },
    mounted() {
      let ua = navigator.userAgent.toLowerCase();
      if (/micromessenger/.test(ua)) {
        Dialog.alert({
          title: '温馨提示',
          message: '点击微信右上角<strong style="font-size: 20px">...</strong>按钮，然后在弹出的菜单中，点击在浏览器中打开 或者点击\'复制链接\'在浏览器中打开',
          confirmButtonText: '我知道了'
        });
      }
      this.getTaskInfo();
    },
    methods: {
      getTaskInfo() {
        const { id } = this.$route.query;
        AJAX.getActivity({ id })
          .then((res) => {
            if (res.success) {
              this.taskInfo = res.result;
            }
          });
      },
      addTaskSubmit() {
        if (this.disabled) return;
        this.disabled = true;
        AJAX.addOfflineTaskSubmit({ id: this.taskInfo.id })
          .then((res) => {
            if (res.success) {
              router.push(`/taskDetail?id=${res.result.id}`);
            }
          })
          .finally(() => {
            this.disabled = false;
          })
      }
    }
  }
</script>

<style scoped>
  .container-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .header {
    position: fixed;
    width: 100%;
    height: 44px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FF8C00;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 18px;
    font-weight: 600;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
  }
  .body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 88px;
    margin-top: 44px;
    .goods-name {
      width: calc(100% - 16px);
      margin: 8px;
      padding: 12px;
      position: relative;
      background: linear-gradient(270deg, #F6DFB8 0%, #F7ECD5 100%);
      box-sizing: border-box;
      border-radius: 8px;
      color: rgb(34, 31, 24);
      font-size: 15px;
      font-weight: bold;
      line-height: 20px;
    }
    .tips {
      width: calc(100% - 16px);
      margin: 0 8px;
      padding: 0 8px;
      box-sizing: border-box;
      div {
        margin-top: 8px;
        font-weight: bold;
        color: #ED0919;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 13px 26px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    text-align: center;
    .btn {
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: #1677FF;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #FFFFFF;
    }
  }
</style>
